import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Skeleton } from '@mui/material';
const DzSidebarHeaderPlaceholder = () => {
    return (_jsxs(Box, Object.assign({ display: "flex", alignItems: "center", columnGap: 1 }, { children: [_jsx(Skeleton, { animation: "wave", variant: "circular", width: 21, height: 21 }), _jsx(Skeleton, { animation: "wave", variant: "text", width: 250, height: 26 }), _jsx(Skeleton, { animation: "wave", variant: "circular", width: 21, height: 21, sx: {
                    marginLeft: 'auto',
                } }), _jsx(Skeleton, { animation: "wave", variant: "circular", width: 21, height: 21 })] })));
};
export default DzSidebarHeaderPlaceholder;
